import type { SxStyle } from '@aibees/shared/theme';

export const root: SxStyle = {
  alignItems: 'flex-start',
};
